import React, { FC } from 'react';
import { KeyContainer } from './KeyContainer';
import { useTranslation } from 'react-i18next';
import { CSVLinkComponent } from './CSVLinkComponent';
import { RightSideContainer } from './RightSideContainer';
import { BASE_URL } from '../../../config/environmentConfig';

interface Props {
  subscriberKey: string;
  loading: boolean;
  csvData?: string[][];
}

export const HmacSigningKey: FC<Props> = (props) => {
  const { subscriberKey, loading, csvData } = props;
  const { t } = useTranslation();

  return (
    <div className="card mb-5">
      <div className="d-md-flex justify-content-md-between">
        <div className="card-body w-md-50">
          <KeyContainer
            value={subscriberKey}
            title={t('WEBHOOKS.SUBSCRIBER_KEY')}
            isVisible
            loading={loading}
            canCopy
            showPass
            copyWithText
            additionalCopyClass="ms-3"
          />
          {
            csvData && (
              <CSVLinkComponent csvData={csvData} filename={t('WEBHOOKS.SUBSCRIBER_KEY')} />
            )
          }
        </div>

        <div className="card-body w-md-50">
          <RightSideContainer
            title={t('WEBHOOKS.SUBSCRIBER_KEY_DESCRIPTION_TITLE')}
            text={t('WEBHOOKS.SUBSCRIBER_KEY_DESCRIPTION_TEXT')}
            linkText={t('API_KEY.LEARN_MORE')}
            link={BASE_URL.HMAC_KEY_URL}
            isUnderLine
          />
        </div>
      </div>
    </div>
  );
};